
import React from 'react';
import {
    Box,
    Grid,
    Alert
} from '@deere/fuel-react';
import {NO_CRITERIA_INFO} from "./Constants";

export const NoCriteriaInfo = ({info=NO_CRITERIA_INFO}) => {
    return (
        <Grid item xs={12}>
            <Box>
                    <Alert
                        variant={"info"}>{info}</Alert>
            </Box>
        </Grid>
    )
}
